import Cookies from 'js-cookie';

interface UserInfo {
	name?: string;
	gender?: string;
	birthday?: string;
	phone?: string;
	email?: string;
	city?: string;
	fullAddress?: string;
}

type CookieKey =
	| 'userName'
	| 'userGender'
	| 'userBirthday'
	| 'userPhone'
	| 'userEmail'
	| 'userCity'
	| 'userFullAddress';

const setUserCookies = (userInfo: UserInfo) => {
	const fieldsToSet: { key: CookieKey; value: string | undefined }[] = [
		{ key: 'userName', value: userInfo.name },
		{ key: 'userGender', value: userInfo.gender },
		{ key: 'userBirthday', value: userInfo.birthday },
		{ key: 'userPhone', value: userInfo.phone },
		{ key: 'userEmail', value: userInfo.email },
		{ key: 'userCity', value: userInfo.city },
		{ key: 'userFullAddress', value: userInfo.fullAddress },
	];

	const { SEVEN_DON_DOMAIN } = process.env;
	const domainValue = SEVEN_DON_DOMAIN?.trim();


	fieldsToSet.forEach(({ key, value }) => {
		if (value !== undefined) {
			Cookies.set(key, value, {
				path: '/',
				expires: 1,
				sameSite: 'strict',
				domain: domainValue,
			});
		}
	});
};

export default setUserCookies;
